import uniqueId from "lodash/uniqueId";

export class PaymentError extends Error {
  public id = uniqueId();

  constructor(public message: string) {
    super(message);
  }
}
